import { render, staticRenderFns } from "./AppSurvey.vue?vue&type=template&id=20e70b72&"
import script from "./AppSurvey.vue?vue&type=script&lang=js&"
export * from "./AppSurvey.vue?vue&type=script&lang=js&"
import style0 from "./AppSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e70b72')) {
      api.createRecord('20e70b72', component.options)
    } else {
      api.reload('20e70b72', component.options)
    }
    module.hot.accept("./AppSurvey.vue?vue&type=template&id=20e70b72&", function () {
      api.rerender('20e70b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AppSurvey.vue"
export default component.exports